<template>
	<div class="container__buttondropdown">
		<button
			:id="id"
			ref="ref__dropdownbutton"
			:class="['ui button', semanticClass]"
			@click="dropdownAtivo = !dropdownAtivo"
		>
			<span>{{ labelSelecionada }}</span>
			<i class="fas fa-caret-down" />
		</button>
		<div
			v-closable="{ exclude: ['ref__dropdownbutton'], handler: 'fecharDropdown' }"
			:class="['container__buttondropdown__drop', { dropdownativo: dropdownAtivo }]"
		>
			<span
				v-for="(option, key) in options"
				:id="option.value"
				:key="key"
				@click="changeValue($event)"
			>
				{{ option.label }}
			</span>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		id: String,
		label: String,
		options: { type: Array, required: true },
		semanticClass: String,
		value: Number,
	},
	data: () => {
		return {
			dropdownAtivo: false,
		}
	},
	computed: {
		labelSelecionada() {
			return this.options.find((f) => f.value === this.value)
				? this.options.find((f) => f.value === this.value).label
				: this.label
		},
	},
	methods: {
		changeValue(value) {
			this.fecharDropdown()

			const prioridadeAntiga = this.value
			var prioridadeNova = parseInt(value.target.id) ? parseInt(value.target.id) : null

			this.$emit('input', prioridadeNova)
			this.$emit('repriorizar', prioridadeNova, prioridadeAntiga, this.id)
		},
		fecharDropdown() {
			this.dropdownAtivo = false
		},
	},
}
</script>

<style scoped>
.container__buttondropdown {
	position: relative;
	font-size: 0.78rem;
	font-family: 'Open Sams', sans-serif;
}

.ui.button {
	width: 100%;
	color: white;
	font-weight: 100;
	display: flex;
	justify-content: space-between;
	background-color: rgb(var(--color-default));
}

.container__buttondropdown__drop {
	display: none;
	position: absolute;
	width: fit-content;
	background-color: white;
	border-bottom-left-radius: 0.28rem;
	border-bottom-right-radius: 0.28rem;
	transform: translateY(-3px);
	z-index: 50;
	max-height: 30vh;
	overflow-y: auto;
}

.ui.button + .container__buttondropdown__drop {
	border-right: 1px solid rgb(var(--color-default));
	border-left: 1px solid rgb(var(--color-default));
	border-bottom: 1px solid rgb(var(--color-default));
	color: rgb(var(--color-default));
}

.container__buttondropdown__drop.dropdownativo {
	display: flex;
	flex-direction: column;
	left: auto;
	right: 0;
	width: 100%;
}

.container__buttondropdown__drop > span {
	padding: 0.2rem 0.5rem;
	cursor: pointer;
	width: 100%;
	text-align: start;
}

.ui.button + .container__buttondropdown__drop > span {
	border-bottom: 1px solid rgba(var(--color-default), 0.2);
}

.ui.button + .container__buttondropdown__drop > span:hover {
	color: white;
	background-color: rgba(var(--color-default));
}
</style>
